import React, { useState } from 'react';
import { FaCloudMoon ,IoSunnyOutline} from "./icons";

import { useStateContext } from "../../context/ContextProvider";

function ToggleDark() {
  const [clicked, setClicked] = useState(false);
  const { setMode, currentMode } = useStateContext();

  const handleThemeChange = () => {
    setClicked(true);
    if (currentMode === 'Dark') {
      setMode('Light');
    } else if (currentMode === 'Light') {
      setMode('Dark');
    }
    setClicked(false);
  }

  return (
    <button
    className="w-11 h-11 flex justify-center items-center text-color-2 bg-white border border-gray-300 outline-none hover:bg-gray-100 ring-4 ring-gray-200 font-medium rounded-lg 800px:text-md text-sm  dark:bg-color-2 bg-opacity-50 dark:bg-opacity-50 dark:text-white dark:hover:bg-gray-700 dark:border-gray-600 dark:ring-gray-700"
      onClick={handleThemeChange}
    >
     {currentMode === 'Dark' ? (
    <FaCloudMoon className="w-5 h-5" /> 
  ) : (
    <IoSunnyOutline className="w-5 h-5" /> 
  )}
    </button>
  );
}

export default ToggleDark;
